import { API } from 'aws-amplify'
import { useCallback, useEffect, useState } from 'react'
import { useLocalization } from '../../../localization'
import { useGlobalState } from '../../../store'
import OrgSyncItem from '../components/OrgSyncItem'; // Assuming this is refactored or doesn't use AntD
import { faInfoCircle, faTrashAlt } from '@fortawesome/free-solid-svg-icons'; // Replaced Ant Design icons
import { ReactComponent as Add } from "../../../images/svg/plus.svg"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// Removed Ant Design imports

// Removed Text, Title imports
import { ReactComponent as Connections } from '../../../images/svg/connections.svg'
import { accountIconMap } from '../../../utils/customIcons'
import ColorPicker from '../../syncs/components/ColorPicker'; // Assuming this is refactored or doesn't use AntD

import { debounce } from 'lodash'
import moment from 'moment'
import momentTz from 'moment-timezone'
// Added CB component imports
import { CBCheckbox } from '../../core/components/CBCheckbox'
import {
  CBAlert,
  CBButton, // Added CBPagination import
  CBCard // Added CBCard import
  ,
  CBHeader,
  CBIncrementer,
  CBInput,
  CBModal, // Added CBAlert
  CBPagination,
  CBRadioGroup,
  SubmitButton
} from '../../core/components/cbd'
import CBInputWithSelectAddon from '../../core/components/CBInputWithSelectAddon'; // Import the new component
import { CBSelect } from '../../core/components/CBSelect'
import { CBSpin } from '../../core/components/CBSpin'
import { CBTable } from '../../core/components/CBTable'; // Import Table (Pagination moved to cbd import)
import { CBTag } from '../../core/components/CBTag'


import {
  sync_plans_new_monthly,
  sync_plans_new_yearly,
  sync_plans_old_monthly,
  sync_plans_old_yearly,
  v2_plans,
  v3_plans,
} from '../components/OrgPrices'; // Assuming this is refactored or doesn't use AntD

// Removed Panel destructuring
// Removed Step destructuring

const theme = {
  scheme: 'google',
  author: 'seth wright (http://sethawright.com)',
  base00: '#1d1f21',
  base01: '#282a2e',
  base02: '#373b41',
  base03: '#969896',
  base04: '#b4b7b4',
  base05: '#c5c8c6',
  base06: '#e0e0e0',
  base07: '#ffffff',
  base08: '#CC342B',
  base09: '#F96A38',
  base0A: '#FBA922',
  base0B: '#198844',
  base0C: '#3971ED',
  base0D: '#3971ED',
  base0E: '#A36AC7',
  base0F: '#3971ED',
};


// --- Helper Functions ---
function getUserSeatLabel(type, org) {
  if (!org?.organization?.orgInterval) return `${type}-monthly`; // Fallback
  return `${type}-${org.organization.orgInterval.includes('monthly') ? 'monthly' : 'yearly'}`;
}
function getUserSeats(type, org) {
  if (!org?.billing?.cbUsers) return 0;
  return org.billing.cbUsers[getUserSeatLabel(type, org)] || 0;
}
function getSyncLabel(org) {
  if (!org?.organization?.orgInterval) return `one-way-sync-monthly`; // Fallback
  return `one-way-sync-${org.organization.orgInterval}`;
}
function getAvailableUserSeats(type, org) {
   if (!org?.billing?.availableMap) return 0;
  return org.billing.availableMap[getUserSeatLabel(type, org)] || 0;
}
function getUsedSyncs(org) {
  if (!org?.billing?.cbBridges) return 0;
  return org.billing.cbBridges[getSyncLabel(org)] || 0;
}
function getAvailableSyncs(org) {
  if (!org?.billing?.availableMap || !org?.organization?.orgInterval) return 0; // Added check for orgInterval
  const intervalKey = `one-way-sync-${org.organization.orgInterval}`;
  return org.billing.availableMap[intervalKey] || 0;
}
function isYearly(org) {
  return org?.organization?.orgInterval?.includes('yearly') || false;
}
function check2022(org) { // Legacy check?
  return org?.organization?.orgInterval?.includes('2022') || false;
}
function checkPro(org) { // Legacy check?
  if (!org?.billing?.stripeBreakdown) return true; // Assume not legacy pro if no breakdown
  return !(org.billing.stripeBreakdown['pro-monthly'] !== undefined || org.billing.stripeBreakdown['pro-yearly'] !== undefined);
}
// --- End Helper Functions ---


// --- BillingPage Component ---
const BillingPage = ({ org }) => {
  const { t } = useLocalization()
  const isYearlyPlan = isYearly(org)
  const is2022 = check2022(org)
  const isProV3 = checkPro(org) // This seems inverted, maybe rename? Assuming it means "is NOT legacy pro"

  const usedSyncs = getUsedSyncs(org)
  const usedAdmin = getUserSeats('admin', org)
  const usedBasics = getUserSeats('basic', org)
  const usedPremium = getUserSeats('premium', org)
  const usedPro = getUserSeats('pro', org) // Legacy Pro
  const usedProV3 = getUserSeats('pro-v3', org) // Current Pro

  const availAdmin = getAvailableUserSeats('admin', org)
  // Ensure availBasic calculation doesn't go below zero
  const availBasicRaw = getAvailableUserSeats('basic', org);
  const availGroupAdmin = getAvailableUserSeats('group-admin', org);
  const availBasic = Math.max(0, availBasicRaw - availGroupAdmin);

  const availPremium = getAvailableUserSeats('premium', org)
  const availPro = getAvailableUserSeats('pro', org)
  const availProV3 = getAvailableUserSeats('pro-v3', org)
  const availSync = getAvailableSyncs(org)

  const [admin, setAdmin] = useState(availAdmin);
  const [basic, setBasic] = useState(availBasic);
  const [groupAdmin, setGroupAdmin] = useState(availGroupAdmin); // Keep track if needed
  const [premium, setPremium] = useState(availPremium);
  const [pro, setPro] = useState(availPro); // Legacy Pro seats
  const [proV3, setProV3] = useState(availProV3); // Current Pro seats
  const [syncs, setSyncs] = useState(availSync);

  const [loading, setLoading] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const [showCancelModal, setShowCancelModal] = useState(false)
  const [error, setError] = useState(null); // Added error state

  async function adjustSeats() { // Removed org param, use from props
    setError(null); // Clear previous errors
    var body = { seats: {} }

    body.seats[getSyncLabel(org)] = usedSyncs + syncs
    body.seats[getUserSeatLabel('admin', org)] = usedAdmin + admin
    body.seats[getUserSeatLabel('basic', org)] = usedBasics + basic + groupAdmin // Add groupAdmin back for total basic
    body.seats[getUserSeatLabel('premium', org)] = usedPremium + premium
    body.seats[getUserSeatLabel('pro', org)] = usedPro + pro // Include legacy pro if needed
    body.seats[getUserSeatLabel('pro-v3', org)] = usedProV3 + proV3 // Include current pro

    try {
      setLoading(true)
      await API.post(
        'organization',
        '/organization/?edit_seats=true&id=' + org.organization.orgId,
        { body }
      )
      location.reload() // Consider state update instead
    } catch (e) {
      console.error("Error adjusting seats:", e);
      setError(e.response?.data?.message || e.message || 'Failed to update seats.'); // Set error state
    } finally {
      setLoading(false)
      setShowModal(false); // Close modal on finish
    }
  }


  async function cancelOrg() { // Removed org param
     setShowCancelModal(false); // Close modal first
     setLoading(true);
     setError(null);
    var body = { seats: {} } // Body might not be needed for cancel
    try {
      await API.post(
        'organization',
        '/organization/?cancel_org=true&id=' + org.organization.orgId,
        { body }
      )
      location.href = window.location.origin + '/dashboard/' // Redirect after cancel
    } catch (e) {
      console.error("Error cancelling org:", e);
      alert(e.response?.data?.message || 'Failed to cancel organization.'); // Use alert for error
    } finally {
      setLoading(false)
    }
  }

  function renderExisting() { // Removed org param
    // Calculate displayed basic users correctly
    const displayedBasic = Math.max(0, usedBasics - groupAdmin);
    return (
      <>
        <div className="text-lg font-semibold mb-2">{t('organization.occupied_seats')}</div>
        {groupAdmin > 0 && <div className="text-md">{t('organization.group_admin_label')} {groupAdmin}</div>}
        <div className="text-md">{t('organization.admin_only_label')} {usedAdmin}</div>
        <div className="text-md">{t('organization.basic_label')} {displayedBasic}</div>
        <div className="text-md">{t('organization.premium_label')} {usedPremium}</div>
        {/* Decide which Pro count to show based on plan type */}
        <div className="text-md">{t('organization.pro_label')} {isProV3 ? usedProV3 : usedPro}</div>
        <div className="text-md">{t('organization.syncs_label')} {usedSyncs}</div>
      </>
    )
  }

  function getPlusMinus(number) {
    if (number == 0) return t('organization.no_change');
    return number < 0 ? `${number}` : `+${number}`;
  }

  function renderSummary() { // Removed org param
    const currentTotalBasic = usedBasics + availBasic + groupAdmin;
    const newTotalBasic = usedBasics + basic + groupAdmin;
    const diffBasic = basic - availBasic; // Difference in *available* basic seats

    const plansSummary = [
        { label: t('organization.basic'), current: currentTotalBasic, newCount: newTotalBasic, diff: diffBasic },
        { label: t('organization.premium'), current: usedPremium + availPremium, newCount: usedPremium + premium, diff: premium - availPremium },
        { label: t('organization.pro'), current: isProV3 ? usedProV3 + availProV3 : usedPro + availPro, newCount: isProV3 ? usedProV3 + proV3 : usedPro + pro, diff: isProV3 ? proV3 - availProV3 : pro - availPro },
        { label: t('organization.admin_only'), current: usedAdmin + availAdmin, newCount: usedAdmin + admin, diff: admin - availAdmin },
        { label: t('organization.syncs'), current: usedSyncs + availSync, newCount: usedSyncs + syncs, diff: syncs - availSync },
    ];

    return (
      <div className="p-4 text-sm"> {/* Adjusted size */}
        <div className="font-semibold mb-2">{t('organization.summary')}</div>
        <div className="mb-2">{isYearlyPlan ? t('organization.yearly') : t('organization.monthly')}</div>
        <table className="w-full border-collapse">
          <thead>
            <tr className="bg-gray-100">
              <th className="border p-2 text-left">{t('organization.plan')}</th>
              <th className="border p-2 text-center">{t('organization.current')}</th>
              <th className="border p-2 text-center">{t('organization.new')}</th>
            </tr>
          </thead>
          <tbody>
            {plansSummary.map(p => (
              <tr key={p.label}>
                <td className="border p-2">{p.label}</td>
                <td className="border p-2 text-center">{p.current}</td>
                <td className="border p-2 text-center">
                  <b>{p.newCount} ({getPlusMinus(p.diff)})</b>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )
  }

  return (
    <div className="m-2 p-4">
      <div className="p-4 m-2 bg-neutral rounded lg:w-2/3">{renderExisting()}</div>
      <div className="lg:w-2/3">
        <p className="mb-4">{t('organization.adjust_available_seats')}</p>

        {/* Seat Adjustments */}
        {[
            { label: t('organization.basic_users'), state: basic, setter: setBasic, avail: availBasic, planKey: 'basic' },
            { label: t('organization.premium_users'), state: premium, setter: setPremium, avail: availPremium, planKey: 'premium' },
            // Determine which pro plan details to show based on isProV3
            { label: t('organization.pro_users'), state: isProV3 ? proV3 : pro, setter: isProV3 ? setProV3 : setPro, avail: isProV3 ? availProV3 : availPro, planKey: isProV3 ? 'pro' : 'pro', isLegacyPro: !isProV3 },
            { label: t('organization.admin_only_users'), state: admin, setter: setAdmin, avail: availAdmin, planKey: 'admin', max: 5 },
            { label: t('organization.admin_syncs'), state: syncs, setter: setSyncs, avail: availSync, planKey: 'sync' } // Special key for syncs
        ].map(seat => {
            const planDetails = seat.planKey === 'sync' ? null : (seat.isLegacyPro ? v2_plans : v3_plans)[seat.planKey]?.[isYearlyPlan ? 'yearly' : 'monthly'];
            const syncPriceMonthly = is2022 ? sync_plans_new_monthly : sync_plans_old_monthly;
            const syncPriceYearly = is2022 ? sync_plans_new_yearly : sync_plans_old_yearly;
            const price = seat.planKey === 'sync'
                ? (isYearlyPlan ? syncPriceYearly : syncPriceMonthly)
                : planDetails?.value;

            return (
                <div key={seat.label} className="grid grid-cols-1 md:grid-cols-2 items-center gap-x-8 p-4 m-2 bg-neutral rounded">
                  <div className="text-md md:text-lg mb-2 md:mb-0">{seat.label}</div>
                  <div className={'flex flex-col sm:flex-row gap-4 items-center'}>
                    <CBIncrementer
                      min={0}
                      onChange={seat.setter}
                      defaultValue={seat.state} // Use state as default value
                      max={seat.max}
                    />
                    {price !== undefined && (
                        <div className="font-bold text-sm">
                          x ${price} / {isYearlyPlan ? t('organization.yearly') : t('organization.monthly')}
                        </div>
                    )}
                  </div>
                </div>
            );
        })}

        {error && <CBAlert variant="error" message={error} className="m-4" />}

        <SubmitButton loading={loading} onClick={(e) => setShowModal(true)} className="mt-6">
          {t('organization.add_remove_seats')}
        </SubmitButton>
      </div>

      <div className="mt-8 p-4 gap-2">
        <CBButton
          disabled={org.syncs?.length !== 0 || org.users?.filter(user => !user.orgAdmin).length > 0} // Corrected logic with optional chaining
          onClick={e=> setShowCancelModal(true)}
          type="danger" // Make it visually distinct
        >
          {t('organization.cancel_organization')}
        </CBButton>
        {org?.syncs?.length > 0 && <div className="text-sm text-red-600 mt-1">{t('organization.all_syncs_must_be_deleted')}</div>}
        {org?.users?.filter(user => !user.orgAdmin).length > 0 && <div className="text-sm text-red-600 mt-1">{t('organization.all_users_must_be_removed')}</div>}
      </div>

      {/* Cancel Org Modal */}
      <CBModal
        disabled={loading}
        positiveLabel={t('organization.confirm_cancel')}
        negativeLabel={t('common.nevermind_button')}
        visible={showCancelModal}
        onPositiveClick={cancelOrg} // Call cancelOrg directly
        onCancelClick={() => setShowCancelModal(false)}
        positiveButtonProps={{ className: 'bg-red-600 hover:bg-red-700' }}
      >
        <div>{t('organization.cancel_org_confirm_message')}</div>
      </CBModal>

      {/* Adjust Seats Modal */}
      <CBModal
        disabled={loading}
        positiveLabel={t('organization.confirm')}
        negativeLabel={t('common.cancel_button')}
        visible={showModal}
        onPositiveClick={adjustSeats} // Call adjustSeats directly
        onCancelClick={() => setShowModal(false)}
      >
        {renderSummary()}
      </CBModal>
    </div>
  )
}
// --- End BillingPage Component ---


// --- OrgItem Component ---
const OrgItem = (props) => {
  const { license, org: orgIdProp } = props; // Destructure props, remove t
  const { t } = useLocalization(); // Use the hook directly
  const [org, setOrg] = useState(null); // Local state for full org data, initialized to null

  // State variables moved inside OrgItem
  const [selectedOption, setSelectedOption] = useState(1);
  const [selectedUserOption, setSelectedUserOption] = useState(1);
  const [checkUserOptions, setCheckUserOptions] = useState(Array(7).fill(true).map((v, i, a) => i === a.length - 1 ? false : v));
  const [showSync, setShowSync] = useState(false);
  const [showUserManagement, setShowUserManagement] = useState(true);
  const [showDomainManagement, setShowDomainManagement] = useState(false);
  const [showBilling, setShowBilling] = useState(false);
  const [syncError, setSyncError] = useState(null);
  const [sourceError, setSourceError] = useState(null); // Added sourceError state
  const [destError, setDestError] = useState(null); // Added destError state
  const [sourceLoad, setSourceLoad] = useState(false);

  const [loading, setLoading] = useState(false);
  const [destLoad, setDestLoad] = useState(false);
  const [disableLoad, setDisableLoad] = useState(false);
  const [quickSyncLoading, setQuickSyncLoading] = useState(false);
  const [quickAddLoading, setQuickAddLoading] = useState(false);
  const [domainError, setDomainError] = useState('');
  const [userError, setUserError] = useState(null);
  const [sourceEmail, setSourceEmail] = useState('');
  const [destEmail, setDestEmail] = useState('');
  const [sourceName, setSourceName] = useState(null);
  const [destName, setDestName] = useState(null);
  const [sourceDomain, setSourceDomain] = useState(0);
  const [destDomain, setDestDomain] = useState(0);
  const [sourceCalendarType, setSourceCalendarType] = useState(null);
  const [destCalendarType, setDestCalendarType] = useState(null);
  const [sourceCalendars, setSourceCalendars] = useState([{ name: t('organization.default'), id: 'Default' }]);
  const [destCalendars, setDestCalendars] = useState([{ name: t('organization.default'), id: 'Default' }]);
  const [selectedSourceCalendar, setSelectedSourceCalendar] = useState(0);
  const [selectedDestCalendar, setSelectedDestCalendar] = useState(0);
  const [sourceCalendarTimezone, setSourceCalendarTimezone] = useState(momentTz.tz.guess());
  const [destCalendarTimezone, setDestCalendarTimezone] = useState(momentTz.tz.guess());
  const [sourceColor, setSourceColor] = useState('default');
  const [destColor, setDestColor] = useState('default');
  const [label, setLabel] = useState('(copy)');
  const [twoWay, setTwoWay] = useState(false); // Note: twoWay UI seems removed, but logic kept
  const [matchColors, setMatchColors] = useState(false);
  const [hasFilters, setHasFilters] = useState(false);
  const [filterFree, setFilterFree] = useState(false);
  const [filterColor, setFilterColor] = useState("none");
  const [excludeInvites, setExcludeInvites] = useState(false);
  const [syncLevel, setSyncLevel] = useState(['free', 'tentative', 'busy', 'oof', 'workingElsewhere']); // Added state for syncLevel
  const [preloads, setPreloads] = useState([]);
  const [preloadName, setPreloadName] = useState(null);
  const [preloadDomain, setPreloadDomain] = useState(0);
  const [addedDomain, setAddedDomain] = useState(null);
  const [showAddDomain, setShowAddDomain] = useState(false); // Unused?
  const [testEmail, setTestEmail] = useState(null);
  const [accept, setAccept] = useState(false);
  const [tennantType, setTennantType] = useState('ms');
  const [admin, setAdmin] = useState(false); // For user add/edit
  const [filterBridges, setFilterBridges] = useState([]);
  const [filterUsers, setFilterUsers] = useState([]);
  const [email, setEmail] = useState(null); // For user add/edit email input
  const [planId, setPlanId] = useState(null); // For user add/edit plan select
  const [currentSyncPage, setCurrentSyncPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [load, setLoad] = useState(false); // Loading state for initial org load
  const [userAddValid, setUserAddValid] = useState(false);
  const [editUser, setEditUser] = useState(false);
  const [showDeleteUserModal, setShowDeleteUserModal] = useState(false);
  const [userToDelete, setUserToDelete] = useState(null);
  const [sourceValid, setSourceValid] = useState(false); // Added sourceValid state
  const [destValid, setDestValid] = useState(false); // Added destValid state
  const [showAddUserForm, setShowAddUserForm] = useState(false); // State for Add User form visibility
  const [showAddSyncForm, setShowAddSyncForm] = useState(false); // State for Add Sync form visibility

  // Define available seats within OrgItem scope
  const isProV3 = checkPro(org); // Needed for pro seat calculation
  const availAdmin = getAvailableUserSeats('admin', org);
  const availBasicRaw = getAvailableUserSeats('basic', org);
  const availGroupAdmin = getAvailableUserSeats('group-admin', org);
  const availBasic = Math.max(0, availBasicRaw - availGroupAdmin);
  const availPremium = getAvailableUserSeats('premium', org);
  const availPro = getAvailableUserSeats('pro', org); // Legacy
  const availProV3 = getAvailableUserSeats('pro-v3', org); // Current


  // --- Methods moved inside OrgItem ---

  // Added generateCSV function
  function generateCSV(orgId){
    if (!org || !org.syncs) return;
    var things = org.syncs.map( item =>{
      return {sourceAccount: item.sourceCalendarAccountId?.replace(`-${orgId}`,"") || '',
      sourceCalendar:item.sourceCalendarName || '',
        destAccount: item.destCalendarAccountId?.replace(`-${orgId}`,"") || '',
        destCalendarName: item.destCalendarName || '',
        status: item.status || '',
        error_message: (item.errorState == "" || item.errorState?.includes("timeout")) ? "None" : item.errorState || '',
        tag: item.tag || '',
        fields: item.securityPolicy || '',
        color: item.destinationColor || '',
      }
    })
    if (things.length === 0) {
        alert("No syncs to export.");
        return;
    }
    const headers = Object.keys(things[0]).join(",") + "\n";
    const rows = things.map(row => Object.values(row).map(val => `"${String(val || '').replace(/"/g, '""')}"`).join(",")).join("\n"); // Handle commas and quotes
    const csvContent = "data:text/csv;charset=utf-8," + headers + rows;

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", `${orgId}-syncs.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  function getTzOptions() {
    return moment.tz.names().map((tz) => ({
      label: `${tz} (${moment.tz(tz).format('Z z')})`,
      value: tz
    }));
  }

  function handleChange(value, position) {
    const domainIndex = parseInt(value);
    const selectedDomain = org?.organization?.allowedDomains?.[domainIndex];
    if (!selectedDomain) return;

    if (position === 'source') {
      setSourceName(''); setSourceDomain(domainIndex); setSourceCalendarType(selectedDomain.type);
      setSourceCalendars([{ id: 'Default', name: t('organization.default') }]); setSelectedSourceCalendar(0);
      setSourceEmail(''); setSourceError(null); setSourceValid(false); // Reset valid state
    } else if (position === 'dest') {
      setDestName(''); setDestEmail(''); setDestDomain(domainIndex); setDestCalendarType(selectedDomain.type);
      setDestCalendars([{ id: 'Default', name: t('organization.default') }]); setSelectedDestCalendar(0);
      setDestError(null); setDestValid(false); // Reset valid state
    } else { // preload
      setPreloadDomain(domainIndex);
    }
  }

  function editUserEntry(id) {
    const user = org?.users?.find((e) => e.userId === id); // Use optional chaining
    if (user) {
      setEditUser(true); setUserAddValid(true); setEmail(user.email);
      setPlanId(user.planId); setAdmin(user.orgAdmin);
      const policy = user.policy;
      if (policy === 'all') {
        setSelectedUserOption(1); setCheckUserOptions(Array(7).fill(true));
      } else if (policy === 'time') {
        setSelectedUserOption(0); setCheckUserOptions(Array(7).fill(false)); // Ensure custom checkboxes are unchecked for 'time'
      } else {
        setSelectedUserOption(2);
        setCheckUserOptions([
          policy.includes('subject'), policy.includes('description'), policy.includes('contact'),
          policy.includes('location'), policy.includes('meeting'), policy.includes('reminder'),
          policy.includes('private'),
        ]);
      }
      setPreloads([]); setPreloadName(''); // Clear preloads when editing
    }
  }

  const selectAfter = (position) => {
    if (!org?.organization?.allowedDomains?.length) return null;
    const options = org.organization.allowedDomains.map((acc, index) => ({
        label: ( // Complex label for dropdown options
            <div key={index.toString()} className="flex items-center justify-between w-full">
                <span>@{acc.domain} ({acc.type})</span> {/* Added type here */} 
                <FontAwesomeIcon icon={accountIconMap[acc.type]?.icon || 'calendar'} className="ml-2" color={accountIconMap[acc.type]?.color || '#888'}/>
            </div>
        ), value: index.toString()
    }));

    // Determine the currently selected domain index and details
    const selectedIndex = (position === 'source' ? sourceDomain : position === 'dest' ? destDomain : preloadDomain);
    const selectedDomainDetails = org.organization.allowedDomains[selectedIndex];
    const iconDetails = accountIconMap[selectedDomainDetails?.type] || { icon: 'calendar', color: '#888' };

    // Return a wrapper containing the select and the icon
    return (
      <div className="flex items-center pl-2 pr-1"> {/* Adjust padding as needed */}
        <CBSelect
          placeholder={t('organization.select_domain_hint')}
          onChange={( v) => {
            handleChange(v, position)
          }}
          selectedValue={selectedIndex.toString()}
          // Use simple string labels including type for the selected value display within CBSelect
          labels={options.map(o => {
              const domainInfo = org.organization.allowedDomains[parseInt(o.value)];
              return `@${domainInfo.domain} (${domainInfo.type})`; // Added type here
          })}
          // Pass the original complex labels for dropdown rendering
          options={options}
          values={options.map(o => o.value)}
          // Remove fixed width, let the container handle it
          // Add classes to remove default CBSelect borders/bg if needed, as the parent now has them
          className="border-0 bg-transparent focus:ring-0 focus:outline-none flex-grow" // Added flex-grow
        />
        <FontAwesomeIcon
          icon={iconDetails.icon}
          className="ml-2" // Add margin between select and icon
          color={iconDetails.color}
        />
      </div>
    );
  }

  async function getCalendars(name, sourceForm) {
    if (!name || name.trim() === '') return;
    const domainIndex = sourceForm === 'source' ? sourceDomain : destDomain;
    const domainInfo = org?.organization?.allowedDomains?.[domainIndex];
    if (!domainInfo) return;

    const email = `${name.trim().toLowerCase()}@${domainInfo.domain}`;
    const type = domainInfo.type;
    setSourceError(null); setDestError(null);
    const setLoading = sourceForm === 'source' ? setSourceLoad : setDestLoad;
    const setError = sourceForm === 'source' ? setSourceError : setDestError;
    const setValid = sourceForm === 'source' ? setSourceValid : setDestValid;
    const setCals = sourceForm === 'source' ? setSourceCalendars : setDestCalendars;
    const setSelectedCal = sourceForm === 'source' ? setSelectedSourceCalendar : setSelectedDestCalendar;
    const setTz = sourceForm === 'source' ? setSourceCalendarTimezone : setDestCalendarTimezone;

    setLoading(true); setValid(false);
    try {
      var calendars = await API.get('organization', `/organization/?calendars=true&id=${encodeURIComponent(email)}&type=${type}`);
      setError(null); setMatchColors(false);
      let items = calendars.items || [];
      if (sourceForm === 'dest') items = items.filter(item => item.canEdit || (item.accessRole && item.accessRole !== 'reader'));

      if (items.length === 0) {
          setError(sourceForm === 'dest' ? t('organization.error_no_writable_calendars') : t('organization.error_no_calendars'));
          setCals([{ name: t('organization.default'), id: 'Default' }]); setSelectedCal(0);
      } else {
          setCals(items); setSelectedCal(0);
          setTz(items[0]?.timeZone || momentTz.tz.guess());
          setValid(true);
      }
    } catch (ex) {
      console.error(`Error fetching ${sourceForm} calendars:`, ex);
      const message = ex.response?.data?.message || t('organization.error_load_calendars', { context: sourceForm });
      setError(message);
      setCals([{ name: t('organization.default'), id: 'Default' }]); setSelectedCal(0);
    } finally { setLoading(false); }
  }

  async function resend(userId) {
    setDisableLoad(true);
    try {
        await API.get('organization', `/organization/?resend=true&id=${encodeURIComponent(userId)}`);
        alert(t('organization.invite_resent_success'));
    } catch (error) {
        console.error("Error resending invite:", error);
        alert(error.response?.data?.message || t('organization.error_resend_invite'));
    } finally { setDisableLoad(false); }
  }

  async function quickSync() {
    setQuickSyncLoading(true); setSourceError(null); setSyncError(null);
    let policy = 'time';
    if (selectedOption === 2) policy = 'all';
    else if (selectedOption === 1) {
      policy = 'time'; // Start with time for custom
      if (checkUserOptions[0]) policy += '|subject'; if (checkUserOptions[1]) policy += '|description';
      if (checkUserOptions[2]) policy += '|contact'; if (checkUserOptions[3]) policy += '|location';
      if (checkUserOptions[4]) policy += '|meeting'; if (checkUserOptions[5]) policy += '|reminder';
      if (checkUserOptions[6]) policy += '|private';
    }
    // Ensure policy is at least 'time' if custom resulted in nothing selected
    if (policy === 'time' && selectedOption === 2 && !checkUserOptions.some(c => c)) {
        // If custom is selected but no boxes checked, maybe default to 'time' or show error?
        // For now, let it be 'time'.
    } else if (policy === 'time' && selectedOption !== 0) { // If not free/busy only, ensure it's not just 'time' unless intended
        // This case might need review depending on desired behavior for custom with no selections
    }


    const sourceCal = sourceCalendars[selectedSourceCalendar];
    const destCal = destCalendars[selectedDestCalendar];
    if ((!sourceCal || sourceCal.id === 'Default') || (!destCal || destCal.id === 'Default')) {
        setSyncError(t('organization.error_select_calendars')); setQuickSyncLoading(false); return;
    }
    const sourceDomainInfo = org?.organization?.allowedDomains?.[sourceDomain];
    const destDomainInfo = org?.organization?.allowedDomains?.[destDomain];
    if (!sourceDomainInfo || !destDomainInfo) {
        setSyncError(t('organization.error_missing_domain')); setQuickSyncLoading(false); return;
    }
    const sourceFullEmail = `${sourceName}@${sourceDomainInfo.domain}`;
    const destFullEmail = `${destName}@${destDomainInfo.domain}`;
    let syncLevelString = syncLevel.join("|"); // Use state syncLevel
    if (filterFree) syncLevelString = syncLevel.filter(l => l !== 'free').join("|");

    try {
      // console.log({
      //   sourceEmail: sourceFullEmail, sourceType: sourceCalendarType,
      //   sourceCalendarId: sourceCal.id === 'Default' ? null : sourceCal.id,
      //   sourceCalendarName: sourceCal.id === 'Default' ? null : (sourceCal.name || sourceCal.summary),
      //   destEmail: destFullEmail, destType: destCalendarType,
      //   destCalendarId: destCal.id === 'Default' ? null : destCal.id,
      //   destCalendarName: destCal.id === 'Default' ? null : (destCal.name || destCal.summary),
      //   policy: policy, sourceColor, destColor, sourceCalendarTimezone, destCalendarTimezone,
      //   tag: label || 'default', twoWay, matchColors, hasFilters, filterColor,
      //   syncLevel: syncLevelString, excludeInvites
      // })
      var orgP = await API.post('organization', `/organization/?id=${orgIdProp}`, { // Use orgIdProp from props
          body: {
            sourceEmail: sourceFullEmail, sourceType: sourceCalendarType,
            sourceCalendarId: sourceCal.id === 'Default' ? null : sourceCal.id,
            sourceCalendarName: sourceCal.id === 'Default' ? null : (sourceCal.name || sourceCal.summary),
            destEmail: destFullEmail, destType: destCalendarType,
            destCalendarId: destCal.id === 'Default' ? null : destCal.id,
            destCalendarName: destCal.id === 'Default' ? null : (destCal.name || destCal.summary),
            policy: policy, sourceColor, destColor, sourceCalendarTimezone, destCalendarTimezone,
            tag: label || 'default', twoWay, matchColors, hasFilters, filterColor,
            syncLevel: syncLevelString, excludeInvites
          },
        });
      setSourceEmail(''); setDestEmail(''); setSourceName(null); setDestName(null);
      setSourceValid(false); setDestValid(false); setMatchColors(false); setLabel('(copy)');
      setSourceCalendars([{ id: 'Default', name: t('organization.default') }]);
      setDestCalendars([{ id: 'Default', name: t('organization.default') }]);
      setSelectedSourceCalendar(0); setSelectedDestCalendar(0); setSyncError(null);
      // Update local org state with new syncs list
      setOrg(prevOrg => ({ ...prevOrg, syncs: (orgP.syncs || []).sort((a, b) => (a.status === 'synced_error' ? -1 : 1)) }));
    } catch (e) {
      console.error("Quick sync failed:", e);
      let errorMsg = t('organization.error_sync_contact_support');
      if (e.response?.data?.message) {
          errorMsg = e.response.data.message.includes('exists') ? (twoWay ? t('organization.error_sync_exists_partial') : t('organization.error_sync_exists')) : e.response.data.message;
      }
      setSyncError(errorMsg);
    } finally { setQuickSyncLoading(false); }
  }

  function clearUser() {
    setEditUser(false); setEmail(null); setPlanId(null); setAdmin(false);
    setSelectedUserOption(1); setCheckUserOptions(Array(7).fill(true));
    setPreloads([]); setPreloadName(''); setQuickAddLoading(false);
    setUserError(null); setUserAddValid(false);
  }

  async function addCustomDomain() {
    setDomainError(''); setQuickSyncLoading(true);
    if (!addedDomain || !testEmail) {
        setDomainError(t('organization.error_domain_email_required')); setQuickSyncLoading(false); return;
    }
    var body = { testEmail: testEmail.toLowerCase() + '@' + addedDomain.toLowerCase(), domain: addedDomain.toLowerCase(), type: tennantType };
    try {
      var orgResponse = await API.post('organization', `/organization/?addDomain=true&id=${orgIdProp}`, { body });
      loadOrganization(orgIdProp); // Reload org data using prop orgId
      setAddedDomain(''); setTestEmail(''); setAccept(false);
    } catch (e) {
      console.error("Error adding domain:", e); setDomainError(e.response?.data?.message || t('organization.error_add_domain'));
    } finally { setQuickSyncLoading(false); }
  }

  async function removeDomain(domain, type) {
    // Add confirmation dialog here?
    setDomainError(''); setQuickSyncLoading(true);
    var body = { domain: domain, type: type };
    try {
      await API.post('organization', `/organization/?removeDomain=true&id=${orgIdProp}`, { body });
      loadOrganization(orgIdProp); // Reload org data
    } catch (e) {
      console.error("Error removing domain:", e); alert(e.response?.data?.message || t('organization.error_remove_domain')); setDomainError(e.response?.data?.message);
    } finally { setQuickSyncLoading(false); }
  }

  async function addAccount() {
    if (!email || !planId) { setUserError(t('organization.error_email_plan_required')); return; }
    setUserError(null); setQuickAddLoading(true);
    let policy = 'time';
    if (selectedUserOption === 1) policy = 'all';
    else if (selectedUserOption === 2) {
      policy = 'time'; // Start with time for custom
      if (checkUserOptions[0]) policy += '|subject'; if (checkUserOptions[1]) policy += '|description';
      if (checkUserOptions[2]) policy += '|contact'; if (checkUserOptions[3]) policy += '|location';
      if (checkUserOptions[4]) policy += '|meeting'; if (checkUserOptions[5]) policy += '|reminder';
      if (checkUserOptions[6]) policy += '|private';
       // Ensure policy is at least 'time' if custom resulted in nothing selected
      if (policy === 'time' && !checkUserOptions.some(c => c)) {
          policy = 'time'; // Default to 'time' if nothing selected in custom
      }
    }

    var body = { email: email.toLowerCase(), orgId: orgIdProp, planId: planId, preloads: preloads, policy, admin: admin };
    try {
      var orgResponse = await API.post('organization', `/organization/?addUser=true&id=${orgIdProp}${editUser ? '&editUser=true' : ''}`, { body });
      clearUser();
      // Update local org state with new users list
      setOrg(prevOrg => ({ ...prevOrg, users: orgResponse.users || [] }));
    } catch (e) {
      console.error("Error adding/editing user:", e); alert(e.response?.data?.message || t('organization.error_user_op_failed')); setUserError(e.response?.data?.message);
    } finally { setQuickAddLoading(false); }
  }

  function showDeleteUserConfirm(user) {
      setUserToDelete(user);
      setShowDeleteUserModal(true);
  }

  async function deleteUserAccount() {
    console.log(userToDelete)
      if (!userToDelete) return;
      const userId = userToDelete.email;
      setShowDeleteUserModal(false); setDisableLoad(true);
      try {
          // Corrected API call for deletion
          const test = await API.del('organization', `/organization/?addUser=true&id=${orgIdProp}&userId=${encodeURIComponent(userId)}`,
              {
                body: {
                email: userId,
                orgId: orgIdProp,
              },
            });
          console.log(test)
          console.log("WHAT")
          loadOrganization(orgIdProp); // Reload org data
      } catch (ex) {
          console.error("Error deleting user:", ex); alert(ex.response?.data?.message || t('organization.error_delete_user'));
      } finally { setDisableLoad(false); setUserToDelete(null); }
  }

  const loadOrganization = useCallback(async (id) => { // Wrap in useCallback
    if (!id) return;
    console.log('Load org ' + id)
    setLoad(true);
    try {
        var orgData = await API.get('organization', '/organization/?id=' + id);
        var nextPage = orgData.nextPage;
        var syncsData = [...(orgData.syncs || [])];
        while(nextPage && nextPage != "") {
          var orgA = await API.get('organization', `/organization/?id=${id}&pageId=${encodeURIComponent(nextPage)}`);
          syncsData.push(...(orgA.syncs || []));
          nextPage = orgA.nextPage;
        }
        syncsData = syncsData.sort((a, b) => (a.status === 'synced_error' ? -1 : 1));
        const loadedOrg = {
          organization: orgData.organization, syncs: syncsData,
          accounts: orgData.accounts || [], users: orgData.users || [],
          schedules: orgData.schedules || [], billing: orgData.orgBreakDown,
        };
        setOrg(loadedOrg); // Set the loaded org data

        // Set initial calendar types based on loaded domains
        if (loadedOrg.organization?.allowedDomains?.length > 0) {
            setSourceCalendarType(loadedOrg.organization.allowedDomains[sourceDomain]?.type);
            setDestCalendarType(loadedOrg.organization.allowedDomains[destDomain]?.type);
        }
         // Set initial planId for user add form
         if (!planId && loadedOrg.organization) {
            setPlanId(getDefaultPlan(loadedOrg));
         }

    } catch (error) { console.error("Failed to load organization data:", error); }
    finally { setLoad(false); }
  }, [orgIdProp, sourceDomain, destDomain, planId]); // Add dependencies

  useEffect(() => {
    loadOrganization(orgIdProp);
  }, [orgIdProp, loadOrganization]); // Rerun loadOrganization if orgIdProp changes

  useEffect(() => {
    if (org) {
      setFilterBridges(org.syncs || []);
      setFilterUsers(org.users || []);
    }
  }, [org]); // Update filters when org data changes

  function onChangeUserPolicy(e) {
      const value = parseInt(e.target.value);
      setSelectedUserOption(value);
      // Reset custom checkboxes if switching away from custom
      if (value !== 2) {
          setCheckUserOptions(Array(7).fill(value === 1)); // All true if 'all', all false if 'time'
      }
  }

  function addPreload() {
    if (preloadName?.trim() && org?.organization?.allowedDomains?.[preloadDomain]) {
      const domain = org.organization.allowedDomains[preloadDomain];
      const fullEmail = `${preloadName.trim().toLowerCase()}@${domain.domain}`;
      if (!preloads.some(p => p.id === fullEmail)) {
          setPreloads([{ id: fullEmail, type: domain.type, domain: domain.domain }, ...preloads]);
      }
      setPreloadName('');
    }
  }

  function getSourceCalendars() {
    return (sourceCalendars || []).map((e, i) => ({ // Add safety check
        label: `${e.name || e.summary}${e.summary && !e.id.endsWith('calendar.google.com') && e.summary !== e.id ? ` - (${e.id})` : ''}`,
        value: i.toString()
    }));
  }
  function getDestCalendars() {
     return (destCalendars || []).map((e, i) => ({ // Add safety check
        label: `${e.name || e.summary}${e.summary && !e.id.endsWith('calendar.google.com') && e.summary !== e.id ? ` - (${e.id})` : ''}`,
        value: i.toString()
    }));
  }

  const loadCalendarDebounced = useCallback(debounce((name, loc) => getCalendars(name, loc), 1000), [org, sourceDomain, destDomain]); // Dependencies for debounce

  function handleSourceChange(value, loc) {
    
    const entry = value.trim();
    const namePart = entry.includes('@') ? entry.substring(0, entry.indexOf('@')) : entry;
    if (loc === 'source') {
      setSourceName(namePart); setSourceEmail(entry);
      if (entry === '') { setSelectedSourceCalendar(0); setSourceValid(false); setSourceCalendars([{ name: t('organization.default'), id: 'Default' }]); }
      else { loadCalendarDebounced(namePart, 'source'); }
    } else {
      setDestName(namePart); setDestEmail(entry);
      if (entry === '') { setSelectedDestCalendar(0); setDestValid(false); setDestCalendars([{ name: t('organization.default'), id: 'Default' }]); }
      else { loadCalendarDebounced(namePart, 'dest'); }
    }
  }

  const validation = (email) => /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(String(email).toLowerCase());

  const handleMenuClick = (key) => {
    setShowBilling(key === 'billing'); setShowSync(key === 'syncs');
    setShowUserManagement(key === 'users'); setShowDomainManagement(key === 'domains');
  }

  function showSyncUI() { return getAvailableSyncs(org) > 0 || !org?.organization?.converted; }
  function showUserUI() {
    if (!org) return false; // Check if org is loaded
    return (getAvailableUserSeats('basic', org) > 0 || getAvailableUserSeats('premium', org) > 0 ||
            getAvailableUserSeats('pro', org) > 0 || getAvailableUserSeats('pro-v3', org) > 0 ||
            getAvailableUserSeats('admin', org) > 0 || !org?.organization?.converted);
  }
  function showConvertPanel() {
    if (!license?.email || !org?.organization) return false;
    return license.email.includes('@calendarbridge.com') && !org.organization.converted;
  }
  async function convertOrg() {
    setLoading(true);
    try {
        await API.post('organization', `/organization/?convertOrg=true&id=${orgIdProp}`, { body: { orgId: orgIdProp } });
        location.reload();
    } catch (error) { console.error("Error converting org:", error); alert(error.response?.data?.message || t('organization.error_convert_org')); setLoading(false); }
  }
  function showConvert() {
    return showConvertPanel() ? (
      <div className="p-4 border-2 border-black rounded-sm text-red-600 mb-4">
        {t('organization.conversion_view_message')}
        <CBButton onClick={convertOrg} loading={loading} className="ml-4">{t('organization.convert_to_new_billing')}</CBButton>
      </div>
    ) : null;
  }

  // getColorOptions remains mostly the same, just use objects for CBSelect
  function getColorOptions() {
    // Use t from props directly
    const noneOption = { value: 'none', label: t('sync.none') };
    const msOptions = [
      { value: "Green category", label: <div className="flex items-center"><div className="w-3 h-3 rounded-full mr-2" style={{ background: '#00ff00' }} /> {t('sync.color_green')}</div> },
      { value: "Yellow category", label: <div className="flex items-center"><div className="w-3 h-3 rounded-full mr-2 bg-yellow-200" /> {t('sync.color_yellow')}</div> },
      { value: "Red category", label: <div className="flex items-center"><div className="w-3 h-3 rounded-full mr-2 bg-red-500" /> {t('sync.color_red')}</div> },
      { value: "Orange category", label: <div className="flex items-center"><div className="w-3 h-3 rounded-full mr-2" style={{ background: 'orange' }} /> {t('sync.color_orange')}</div> },
      { value: "Blue category", label: <div className="flex items-center"><div className="w-3 h-3 rounded-full mr-2" style={{ background: 'blue' }} /> {t('sync.color_blue')}</div> },
      { value: "Purple category", label: <div className="flex items-center"><div className="w-3 h-3 rounded-full mr-2" style={{ background: 'purple' }} /> {t('sync.color_purple')}</div> },
    ];
    const googleOptions = [
       { value: "11", label: <div className="flex items-center"><div className="w-3 h-3 rounded-full mr-2" style={{ background: '#D50000' }} /> {t('sync.color_tomato')}</div> },
       { value: "10", label: <div className="flex items-center"><div className="w-3 h-3 rounded-full mr-2" style={{ background: '#0B8043' }} /> {t('sync.color_basil')}</div> },
       { value: "9", label: <div className="flex items-center"><div className="w-3 h-3 rounded-full mr-2" style={{ background: '#3F51B5' }} /> {t('sync.color_blueberry')}</div> },
       // Add other Google colors if needed
    ];
    // Determine type based on source calendar type for filtering
    if (sourceCalendarType === 'ms' || sourceCalendarType === 'ews') return [noneOption, ...msOptions];
    else if (sourceCalendarType === 'google') return [noneOption, ...googleOptions];
    else return [noneOption]; // Default if type is unknown
  }

  // Helper to get default plan ID based on available seats
  function getDefaultPlan(currentOrg) {
      if (!currentOrg?.organization) return 'basic-monthly'; // Default fallback

      const isMonthly = currentOrg.organization.orgInterval?.includes('monthly');
      const interval = isMonthly ? 'monthly' : 'yearly';

      if (!currentOrg.organization.converted || getAvailableUserSeats('basic', currentOrg) > 0) return `basic-${interval}`;
      if (getAvailableUserSeats('premium', currentOrg) > 0) return `premium-${interval}`;
      if (getAvailableUserSeats('pro-v3', currentOrg) > 0) return `pro-v3-${interval}`; // Check v3 first
      if (getAvailableUserSeats('pro', currentOrg) > 0) return `pro-${interval}`; // Then legacy pro
      if (getAvailableUserSeats('admin', currentOrg) > 0) return `admin-${interval}`;

      return `basic-${interval}`; // Fallback if no seats available (shouldn't happen if showUserUI is true)
  }


  // getPlans function adapted for CBSelect
  function getPlans() {
      if (!org?.organization) return null; // Don't render if org not loaded

      const isMonthly = org.organization.orgInterval?.includes('monthly');
      const interval = isMonthly ? 'monthly' : 'yearly';
      const converted = org.organization.converted;

      const options = [];

      if (!converted || getAvailableUserSeats('basic', org) > 0) options.push({ value: `basic-${interval}`, label: t(`organization.basic_${interval}_syncs`) });
      if (!converted || getAvailableUserSeats('premium', org) > 0) options.push({ value: `premium-${interval}`, label: t(`organization.premium_${interval}_syncs`) });
      if (!converted || getAvailableUserSeats('pro', org) > 0) options.push({ value: `pro-${interval}`, label: t(`organization.pro_${interval}_syncs`) }); // Legacy Pro
      if (!converted || getAvailableUserSeats('pro-v3', org) > 0) options.push({ value: `pro-v3-${interval}`, label: t(`organization.pro_v3_${interval}_syncs`) }); // V3 Pro
      if (!converted || getAvailableUserSeats('admin', org) > 0) options.push({ value: `admin-${interval}`, label: t(`organization.admin_${interval}_syncs`) });

      // Set default planId if not set
      const currentDefaultPlan = getDefaultPlan(org);
      if (planId === null && options.length > 0) {
          setPlanId(currentDefaultPlan);
      }

      return (
          <CBSelect
              style={{ marginTop: 8, width: '100%' }} // Use full width
              selectedValue={planId || currentDefaultPlan} // Use state or default
              onChange={( val) => {
                  if (val.includes('admin')) setAdmin(true); // Auto-check admin for admin plan
                  // else setAdmin(false); // Should we uncheck if switching away? Maybe not.
                  setPlanId(val);
              }}
              labels={options.map(o => o.label)}
              values={options.map(o => o.value)}
              placeholder={t('organization.select_plan')}
          />
      );
  }


  function itemRender(current, type, originalElement) { // For Pagination
    if (type === 'prev') return <a>{t('organization.previous')}</a>;
    if (type === 'next') return <a>{t('organization.next')}</a>;
    return originalElement;
  }

  function getTotal(){ return org?.syncs?.length || 0; }

  // Define columns for the user table
  const userTableColumns = [
    { title: t('common.email'), dataIndex: 'email', key: 'email', sorter: (a, b) => a.email.localeCompare(b.email) },
    {
      title: t('organization.plan'), dataIndex: 'planId', key: 'planId',
      render: (planId) => <CBTag color={'blue'}>{planId?.split('-')[0]?.toUpperCase() || 'N/A'}</CBTag>,
      filters: [...new Set((org?.users || []).map(u => u.planId?.split('-')[0]).filter(Boolean))].map(p => ({ text: p.toUpperCase(), value: p })),
      onFilter: (value, record) => record.planId?.startsWith(value),
    },
    {
      title: t('organization.policy'), dataIndex: 'policy', key: 'policy',
      render: (tags) => (
        <span className="flex flex-wrap gap-1">
          {(tags || '').split('|').map((tag) => (
            <CBTag color={tag === 'all' || tag === 'time' ? 'green' : 'red'} key={tag}>
              {tag.toUpperCase()}
            </CBTag>
          ))}
        </span>
      ),
    },
    {
      title: t('organization.type'), dataIndex: 'orgAdmin', key: 'orgAdmin',
      render: (isAdmin) => <span>{isAdmin ? t('organization.admin') : t('organization.standard')}</span>,
      filters: [ { text: t('organization.admin'), value: true }, { text: t('organization.standard'), value: false } ],
      onFilter: (value, record) => record.orgAdmin === value,
    },
    {
      title: t('organization.active'), dataIndex: 'userId', key: 'userIdActive',
      render: (userId) => <div>{userId?.includes('us-east') ? t('organization.active') : t('organization.needs_login')}</div>,
       filters: [ { text: t('organization.active'), value: true }, { text: t('organization.needs_login'), value: false } ],
       onFilter: (value, record) => (record.userId?.includes('us-east')) === value,
    },
    {
      title: t('organization.options'), dataIndex: 'userId', key: 'userIdOptions', width: 250, // Adjust width as needed
      render: (userId, record) => {
        const isInvitePending = !userId?.includes('us-east');
        return (
          <div className="flex space-x-2 flex-wrap gap-1"> {/* Allow wrapping */}
            <CBButton type="ternary" size="small" loading={disableLoad} onClick={() => editUserEntry(userId)}>
              {t('organization.edit')}
            </CBButton>
            {isInvitePending && (
              <CBButton type="ternary" size="small" loading={disableLoad} onClick={() => resend(userId)}>
                {t('organization.resend_invite')}
              </CBButton>
            )}
            {/* Disable delete for self */}
            <CBButton size="small" type="danger" loading={disableLoad} onClick={() => showDeleteUserConfirm(record)} disabled={license.email === record.email}>
              {t('common.delete_button')}
            </CBButton>
          </div>
        );
      },
    },
  ];
  
  // console.log(org) // Keep for debugging if needed
  return (
    <div className="mt-6"> {/* Replaced style */}
      {!org && load && ( // Show loading only if org is null AND load is true
        <center className="mt-8">
          <CBSpin spinning={true} size="large"  />
        </center>
      )}

      {org && org.organization.stripeId == 'pending' && (
        <div className="p-4 bg-yellow-100 border border-yellow-300 rounded text-yellow-800">
          {t('organization.complete_checkout_prompt')}{' '}
          <a href="organization/new" className="underline font-semibold">{t('organization.complete_checkout_link')}</a>
        </div>
      )}
      {org && org.organization.stripeId != 'pending' && (
        <div>
          {/* Tab-like Navigation */}
          <div className="flex mb-4 border-b border-gray-300 gap-4 items-center"> {/* Removed space-x-1, adjusted border color */}
              <CBButton className="px-4 py-2 rounded-t-md" type={showUserManagement ? "primary-tab" : "ternary-tab"} onClick={() => handleMenuClick('users')}>{t('organization.manage_users')}</CBButton>
              {((org.organization.allowedDomains?.length > 0) || org.organization.converted) && (
                  <CBButton className="px-4 py-2 rounded-t-md" type={showSync ? "primary-tab" : "ternary-tab"} onClick={() => handleMenuClick('syncs')}>{t('organization.manage_syncs')}</CBButton>
              )}
              <CBButton className="px-4 py-2 rounded-t-md" type={showDomainManagement ? "primary-tab" : "ternary-tab"} onClick={() => handleMenuClick('domains')}>{t('organization.manage_domains')}</CBButton>
              {(org.organization.converted || showConvertPanel()) && (
                  <CBButton className="px-4 py-2 rounded-t-md" type={showBilling ? "primary-tab" : "ternary-tab"} onClick={() => handleMenuClick('billing')}>{t('organization.manage_billing')}</CBButton>
              )}
          </div>

          {showBilling && <BillingPage org={org} />}

          {showSync && (
              <>
                {(org.organization.converted || showConvertPanel()) && (
                  <>
                    {showConvert()}
                    <div className="m-4 lg:w-1/2 text-lg p-4 bg-neutral rounded">
                      {t('organization.available_sync_seats')} {getAvailableSyncs(org)}
                    </div>
                    {!showSyncUI() && (
                      <div className="p-4 m-4 text-lg cursor-pointer text-blue-600 hover:underline"
                           onClick={() => handleMenuClick('billing')}>
                        {t('organization.purchase_sync_seats')}
                      </div>
                    )}
                  </>
                )}
                {/* Add Sync Toggle Button */}
                {showSyncUI() && org.organization.allowedDomains?.length > 0 && (
                  <div className="mb-4 w-[600px]">
                    <CBButton long={true}
                icon={showAddSyncForm ? <div></div> : <Add style={{float:'right'}} ></Add>} type={showAddSyncForm ? 'ternary' : 'primary'} onClick={() => setShowAddSyncForm(!showAddSyncForm)}>
                      {showAddSyncForm ? t('organization.hide_add_sync_form') : t('organization.add_sync')}
                    </CBButton>
                  </div>
                )}
                {/* Conditionally render Add Sync Form */}
                {showAddSyncForm && showSyncUI() && org.organization.allowedDomains?.length > 0 ? (
                  <CBCard icon={<div></div>} className="mb-4 lg:w-2/3" title={t('organization.add_sync')}>
                    <div className=""> {/* Use vertical spacing instead of grid */}
                      {/* Title is now handled by CBCard prop */}
                          {/* Source Section */}
                           {/* Added space between elements */}
                              <div className="text-xl ml-2">{t('sync.source')}</div>
                              <CBInputWithSelectAddon
                                  value={sourceEmail} placeholder={t('organization.address')}
                                  onChange={(val) => handleSourceChange(val, 'source')}
                                  addonElement={selectAfter('source')} // Use addonElement
                              />
                              {sourceError && <CBAlert variant="error" message={sourceError} />}
                              <div className="text-xl ml-2 mt-2" >{t('organization.source_calendar')}</div>
                              {sourceCalendars && (
                                  <div className="flex items-center">
                                      <CBSelect
                                          size="large" placeholder={t('organization.select_calendar')}
                                          style={{ width: '100%' }} 
                                          selected={selectedSourceCalendar}
                                          onChange={(idx) => {
                                              console.log("SOURCE CALENDAR SELECT")
                                              console.log(idx)
                                              const index = idx; setSelectedSourceCalendar(index);
                                              const cal = sourceCalendars[index];
                                              if (cal?.timeZone) setSourceCalendarTimezone(cal.timeZone);
                                              else setSourceCalendarTimezone(momentTz.tz.guess());
                                          }}
                                          labels={getSourceCalendars().map(o => o.label)} 
                                          values={getSourceCalendars().map(o => o.value)}
                                      />
                                      {sourceLoad && <CBSpin spinning={true} className="ml-2"/>}
                                  </div>
                              )}
                              {/* Timezone Select */}
                              {sourceCalendarType && sourceCalendarType !== 'google' && (
                                  <div>
                                      <div className="text-xl ml-2 mt-2">{t('organization.source_calendar_timezone')}</div>
                                      <CBSelect
                                          showSearch size="small" style={{ width: '100%' }}
                                          placeholder={t('sync.select_timezone_placeholder')}
                                          labels={getTzOptions().map(o => o.label)} 
                                          values={getTzOptions().map(o => o.value)}
                                          selected={getTzOptions().map(o => o.value).indexOf(sourceCalendarTimezone)} 
                                          onChange={(idx) => {setSourceCalendarTimezone(getTzOptions().map(o => o.value)[idx])}}
                                      />
                                  </div>
                              )}
                               {sourceCalendarType === 'google' && (
                                  <div>
                                      <div className="text-xl ml-2 mt-4">{t('organization.source_calendar_timezone')}</div>
                                      <p className="text-lg p-1 border-b mt-2 w-64">{sourceCalendarTimezone}</p>
                                  </div>
                              )}
                          
                          {/* Destination Column */}
                          <div className=""> {/* Added space between elements */}
                              <div className="text-xl ml-2 mt-4">{t('sync.destination')}</div>
                              <CBInputWithSelectAddon
                                  value={destEmail} placeholder={t('organization.address')}
                                  onChange={(val) => handleSourceChange(val, 'dest')}
                                  addonElement={selectAfter('dest')} // Use addonElement
                              />
                              {destError && <CBAlert variant="error" message={destError} />}
                              <div className="text-xl ml-2 mt-4">{t('organization.destination_calendar')}</div>
                              {destCalendars && (
                                  <div className="flex items-center">
                                      <CBSelect
                                          size="large" placeholder={t('organization.select_calendar')}
                                          style={{ width: '100%' }} 
                                          selected={selectedDestCalendar} 
                                          onChange={(idx) => {
                                            console.log("DEST CALENDAR SELECT")
                                              console.log(idx)
                                            const index = idx; 
                                            setSelectedDestCalendar(index);
                                              const cal = destCalendars[index];
                                              if (cal?.timeZone) setDestCalendarTimezone(cal.timeZone);
                                              else setDestCalendarTimezone(momentTz.tz.guess());
                                          }}
                                          labels={getDestCalendars().map(o => o.label)} 
                                          values={getDestCalendars().map(o => o.value)}
                                      />
                                      {destLoad && <CBSpin spinning={true} className="ml-2"/>}
                                  </div>
                              )}
                               {/* Timezone Select */}
                               {destCalendarType && destCalendarType !== 'google' && (
                                  <div>
                                      <div className="text-xl ml-2 mt-4">{t('organization.destination_calendar_timezone')}</div>
                                      <CBSelect
                                          showSearch size="small" style={{ width: '100%' }}
                                          placeholder={t('sync.select_timezone_placeholder')}
                                          labels={getTzOptions().map(o => o.label)} 
                                          values={getTzOptions().map(o => o.value)}
                                          selectedValue={getTzOptions().map(o => o.value).indexOf(destCalendarTimezone)} 
                                          onChange={(idx) => {setDestCalendarTimezone(getTzOptions().map(o => o.value)[idx])}}
                                      />
                                  </div>
                              )}
                               {destCalendarType === 'google' && (
                                  <div>
                                      <div className="text-xl ml-2 mt-4">{t('organization.destination_calendar_timezone')}</div>
                                      <p className="text-lg p-1 border-b mt-2 w-64">{destCalendarTimezone}</p>
                                  </div>
                              )}
                          </div>
                      {/* Removed extra closing div from grid */}
                      {/* Sync Options */}
                      
                          <div className="text-xl ml-2 mt-4">{t('sync.fields')}</div>
                          <CBRadioGroup
                              onChange={(val) => setSelectedOption(parseInt(val))} // Use setSelectedOption
                              selectedValue={selectedOption.toString()}
                              labels={[ t('organization.free_busy_only'),t('organization.custom')]}
                              values={['0','1']}
                              selected={selectedOption}
                              className="mb-3" // Added margin
                          />
                          {/* Custom Checkboxes */}
                          {(selectedOption === 2 || selectedOption === 1) && checkUserOptions && (
                              <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2 mt-4 mb-4 border p-3 rounded bg-gray-50"> {/* Added border/bg */}
                                  {[
                                      { label: t('sync.field_subject'), index: 0 }, { label: t('sync.field_description'), index: 1 },
                                      { label: t('sync.field_attendees'), index: 2 }, { label: t('sync.field_location'), index: 3 },
                                      { label: t('sync.field_conference'), index: 4 }, { label: t('sync.field_reminders'), index: 5 },
                                      { label: t('sync.field_all_private'), index: 6 },
                                  ].map(opt => (
                                      <CBCheckbox
                                          key={opt.index} checked={checkUserOptions[opt.index]}
                                          onChange={(e) => { const newOpts = [...checkUserOptions]; newOpts[opt.index] = e; setCheckUserOptions(newOpts); }}
                                          disabled={selectedOption === 0} label={opt.label}
                                      />
                                  ))}
                              </div>
                          )}
                           {selectedOption === 0 && (
                               <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2  border p-3 rounded bg-gray-50 opacity-60"> {/* Added border/bg */}
                                   {[
                                       t('sync.field_subject'), t('sync.field_description'), t('sync.field_attendees'),
                                       t('sync.field_location'), t('sync.field_conference'), t('sync.field_reminders'),
                                       t('sync.field_all_private')
                                   ].map(label => <CBCheckbox key={label} checked={false} disabled={true} label={label} />)}
                               </div>
                           )}
                      {/* Tag Input & Color */}
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-2 "> {/* Increased margin/gap */}
                          <div>
                              <div className="text-xl ml-2 mt-4">{t('sync.tag')}</div>
                              <CBInput
                                  disabled={label === ' '} value={label === ' ' ? '' : label}
                                  hint={t('sync.tag_copy_placeholder')} onChange={(val) => setLabel(val)}
                              />
                              <CBCheckbox
                                  className="mt-1 text-xs" checked={label === ' '} // Smaller text
                                  onChange={(e) => setLabel(e ? ' ' : '(copy)')}
                                  label={<>{t('sync.no_tag')} (<a href="https://help.calendarbridge.com/doc/getting-started/setting-up-calendar-syncing/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">{t('organization.not_recommended')}</a>)</>}
                              />
                          </div>
                          {/* Moved Color Pickers below Tag */}
                      </div>
                      {/* Color Pickers Section */}
                      <div className=""> {/* Add margin for separation */}
                          <div className="text-xl mb-4 mt-4">{t('organization.destination_copy_color')}</div>
                          <ColorPicker type={destCalendarType} onColorChangeCallback={setDestColor} color={destColor} />
                          {destCalendarType === sourceCalendarType && (
                              <div className="mt-2">
                                  <CBCheckbox checked={matchColors} onChange={setMatchColors} label={t('sync.match_source_colors')} />
                              </div>
                          )}
                      </div>
                       {/* Filtering Options */}
                       <div className="mb-4 mt-2"> {/* Increased margin */}
                           <div className="text-xl mb-4 mt-4">{t('sync.filtering')}</div>
                           <div className="flex flex-col gap-2 border p-3 rounded bg-gray-50"> {/* Added border/bg */}
                               <CBCheckbox
                                   checked={filterFree}
                                   onChange={(e) => { setFilterFree(e); setHasFilters(e || filterColor !== 'none' || excludeInvites); }}
                                   label={t('sync.exclude_free_events')}
                               />
                               {sourceCalendarType === 'google' && (
                                   <CBCheckbox
                                       checked={excludeInvites}
                                       onChange={(e) => { setExcludeInvites(e); setHasFilters(filterFree || filterColor !== 'none' || e); }}
                                       label={t('sync.exclude_unaccepted_invites')}
                                   />
                               )}
                               <div className="flex items-center gap-2 mt-2">
                                   <label className="text-sm">{t('sync.exclude_source_events_color')}</label>
                                   <CBSelect
                                       size="small" style={{ width: 200 }} placeholder={t('sync.select_color_filter')}
                                       selectedValue={filterColor}
                                       onChange={(val) => { setFilterColor(val); setHasFilters(filterFree || val !== 'none' || excludeInvites); }}
                                       labels={getColorOptions().map(o => o.label)} values={getColorOptions().map(o => o.value)}
                                   />
                               </div>
                           </div>
                       </div>

                      <CBButton
                        loading={quickSyncLoading}
                        disabled={!sourceValid || !destValid || quickSyncLoading} // Corrected disabled check
                        type="primary" className="mt-6" onClick={quickSync}
                      >
                        {t('sync.create_sync_button')}
                      </CBButton>
                      {syncError && <CBAlert variant="error" message={syncError} className="mt-2"/>}
                    </div>
                  </CBCard>
                ) : !org?.organization?.allowedDomains ? ( // Check if org is loaded
                  <div className="p-4 text-center text-gray-600">{t('organization.add_domain_first')}</div>
                ) : null}

                {/* Syncs List */}
                <CBCard icon={<div></div>} title={t('organization.syncs') + " " + org?.syncs?.length} className="mt-6 mb-4">
                  <div className="flex items-center justify-between mb-4 flex-wrap gap-2"> {/* Added wrap */}
                      {!load && org?.syncs?.length > 0 && (
                          <div className="flex items-center space-x-4">
                              <CBButton type="primary" size="small" onClick={() => generateCSV(org.organization.orgId)}>{t('organization.export_csv')}</CBButton>
                              <CBButton type="ternary" size="small" onClick={() => loadOrganization(org.organization.orgId)} loading={load}>{t('organization.refresh')}</CBButton> {/* Added loading state */}
                          </div>
                      )}
                  </div>
                  {load && <div className="text-center p-4">{t('organization.updating_syncs')}...</div>}
                  <div className="mb-4">
                    <CBInput
                      hint={t('organization.search_syncs_placeholder')}
                      allowClear
                      onChange={(val) => {
                        setCurrentSyncPage(1);
                        if (!val || val === '') setFilterBridges(org?.syncs || []);
                        else {
                          const searchTerm = val.toLowerCase();
                          setFilterBridges((org?.syncs || []).filter(b =>
                              b.sourceCalendarAccountId?.toLowerCase().includes(searchTerm) ||
                              b.destCalendarAccountId?.toLowerCase().includes(searchTerm) ||
                              b.sourceCalendarName?.toLowerCase().includes(searchTerm) ||
                              b.destCalendarName?.toLowerCase().includes(searchTerm) ||
                              b.tag?.toLowerCase().includes(searchTerm) // Added tag search
                          ));
                        }
                      }}
                    />
                  </div>
                  <CBPagination
                    current={currentSyncPage} total={filterBridges.length} pageSize={pageSize}
                    onChange={(page, size) => { setCurrentSyncPage(page); setPageSize(size); }}
                    className="mb-4" showSizeChanger // Allow changing page size
                    pageSizeOptions={['10', '25', '50', '100']} // Options for page size
                  />
                  <div className="space-y-2 mt-4">
                    {filterBridges.slice((currentSyncPage - 1) * pageSize, currentSyncPage * pageSize).map((sync) => (
                      <OrgSyncItem item={sync} key={sync.id} deleteCallback={() => loadOrganization(org.organization.orgId)} />
                    ))}
                    {filterBridges.length === 0 && !load && <p className="text-center text-gray-500">{t('organization.no_syncs_found')}</p>}
                  </div>
                   {filterBridges.length > pageSize && ( // Show bottom pagination only if needed
                       <CBPagination
                           current={currentSyncPage} total={filterBridges.length} pageSize={pageSize}
                           onChange={(page, size) => { setCurrentSyncPage(page); setPageSize(size); }}
                           className="mt-4"
                       />
                   )}
                </CBCard>
              </>
            )}

          {showUserManagement && (
            <>
              {(org?.organization?.converted || showConvertPanel()) && ( // Check if org is loaded
                <>
                  {showConvert()}
                  <div className="text-lg m-4">{t('organization.available_seat_summary')}</div>
                  <div className="flex flex-col flex-wrap m-4 text-lg p-4 bg-neutral lg:w-1/2 rounded"> {/* Smaller text */}
                    <div>{t('organization.basic_label')} {availBasic}</div>
                    <div>{t('organization.premium_label')} {availPremium}</div>
                    <div>{t('organization.pro_label')} {isProV3 ? availProV3 : availPro}</div>
                    <div>{t('organization.admin_only_label')} {availAdmin}</div>
                  </div>
                </>
              )}
              {/* Add User Toggle Button */}
              {showUserUI() && !editUser && ( // Show toggle only if seats available and not editing
                <div className="mb-4 w-[600px] justify-center">
                  <CBButton long={true}
                icon={<Add style={{float:'right'}} ></Add>} type={showAddUserForm ? 'ternary' : 'primary'} onClick={() => setShowAddUserForm(!showAddUserForm)}>
                    {showAddUserForm ? t('organization.hide_add_user_form') : t('organization.add_user')}
                  </CBButton>
                </div>
              )}
              {/* Conditionally render Add/Edit User Form */}
              {(showAddUserForm || editUser) && (showUserUI() || editUser) ? (
                <CBCard icon={<div></div>} className="mb-4 lg:w-2/3" title={editUser ? t('organization.edit_user') : t('organization.add_user')}> {/* Optional: Limit width like other sections */}
                  <div className="space-y-2"> {/* Use simple vertical spacing */}
                    {/* Title is now handled by CBCard prop */}

                    {/* User Email Input */}
                    <div>
                      {/* <label className="block text-sm font-medium text-gray-700 mb-1">{t('organization.user_email')}</label> */}
                      <CBInput
                        label={t('organization.user_email')}
                        disabled={editUser} placeholder={t('organization.user_email')}
                        value={email || ''}
                        onChange={(val) => { setEmail(val.trim().toLowerCase()); setUserAddValid(validation(val.trim().toLowerCase())); }}
                      />
                      {!showUserUI() && editUser && <CBAlert variant="warning" message={t('organization.change_plan_seat_warning')} className="mt-1 text-xs"/>}
                      {userError && <CBAlert variant="error" message={userError} className="mt-1 text-xs"/>}
                    </div>

                    {/* Plan Selection */}
                    <div className="flex items-center space-x-2">
                      <label className="block text-sm font-medium text-gray-700 w-16">{t('organization.plan_label')}</label>
                      <div className="flex-grow">
                        {org?.organization && getPlans()}
                      </div>
                    </div>

                    {/* Managed Calendar Accounts */}
                    {org?.organization?.allowedDomains?.length > 0 && (
                        <div className="space-y-3 pt-2">
                            <h4 className="text-sm font-semibold">{t('organization.include_managed_accounts')}</h4>
                            <CBInputWithSelectAddon
                                placeholder={t('organization.address_placeholder')}
                                value={preloadName || ''}
                                onChange={(val) => { // Assuming CBInputWithSelectAddon passes value directly
                                    const entry = val.trim();
                                    const namePart = entry.includes('@') ? entry.substring(0, entry.indexOf('@')) : entry;
                                    setPreloadName(namePart);
                                }}
                                addonElement={selectAfter('preload')} // Changed prop name
                            />
                            <CBButton size="small" disabled={!preloadName?.trim()} onClick={addPreload}>
                                {t('organization.add_calendar_account')}
                            </CBButton>
                            {preloads?.length > 0 && (
                                <div className="mt-2 space-y-1 max-h-32 overflow-y-auto border p-2 rounded bg-gray-50">
                                    {preloads.map((acc) => (
                                        <div key={acc.id} className="flex justify-between items-center text-xs p-1 bg-gray-100 rounded">
                                            <span>{acc.id}</span>
                                            <button onClick={() => setPreloads(preloads.filter(item => acc.id !== item.id))} className="text-red-500 hover:text-red-700 ml-2">&times;</button>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    )}
{/* Admin Access Checkbox */}
<CBCheckbox className="pt-2" checked={admin} onChange={setAdmin} label={t('organization.admin_access')} disabled={license.email === email && editUser} />
{/* <CBRadioGroup
                      onChange={onTzChange}
                      selectedValue={tz} // Use selectedValue prop if available
                      className="flex flex-col space-y-1" // Vertical layout
                      labels={timezoneLabels}
                      values={timezoneValues}
                   /> */}
{/* Access Control Policy */}
<div className="pt-2"> {/* Restoring wrapper div */}
  <div className="text-sm font-semibold mb-1">{t('organization.access_control_policy')}</div> {/* Removed pt-2 from here */}
  <CBRadioGroup
  title={""}
  onChange={( val) => onChangeUserPolicy({ target: { value: parseInt(val) } })} // Pass event-like object
  selected={selectedUserOption.toString()}
  labels={[t('organization.free_busy_only'),t('organization.all_fields'),t('organization.custom')]}
  values={['0','1','2']}
                      className="mb-3" // Added margin
                    />
                    {(selectedUserOption === 2 || selectedUserOption === 1) && checkUserOptions && (
                        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2 mt-4 mb-4 border p-3 rounded bg-gray-50"> {/* Added border/bg */}
                            {[
                                { label: t('sync.field_subject'), index: 0 }, { label: t('sync.field_description'), index: 1 },
                                { label: t('sync.field_attendees'), index: 2 }, { label: t('sync.field_location'), index: 3 },
                                { label: t('sync.field_conference'), index: 4 }, { label: t('sync.field_reminders'), index: 5 },
                                { label: t('sync.field_all_private'), index: 6 },
                            ].map(opt => (
                                <CBCheckbox
                                    key={opt.index} checked={checkUserOptions[opt.index]}
                                    onChange={(e) => { const newOpts = [...checkUserOptions]; newOpts[opt.index] = e; setCheckUserOptions(newOpts); }}
                                    disabled={selectedUserOption === 1} label={opt.label}
                                />
                            ))}
                        </div>
                    )}
                     {selectedUserOption === 0 && (
                         <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2 mt-4 mb-4 border p-3 rounded bg-gray-50 opacity-60"> {/* Added border/bg */}
                             {[
                                 t('sync.field_subject'), t('sync.field_description'), t('sync.field_attendees'),
                                 t('sync.field_location'), t('sync.field_conference'), t('sync.field_reminders'),
                                 t('sync.field_all_private')
                             ].map(label => <CBCheckbox key={label} checked={false} disabled={true} label={label} />)}
                         </div>
                     )}
                    </div> {/* Closing tag for Access Control Policy section wrapper */}
                  </div> {/* Closing tag for the main space-y-4 wrapper */}

                  {/* Buttons outside the main form wrapper, but inside the card */}
                  <div className="flex space-x-2 mt-6"> {/* Added more top margin */}
                      <CBButton
                        type="primary" loading={quickAddLoading}
                        disabled={!userAddValid || !planId}
                        onClick={addAccount}
                      >
                        {editUser ? t('organization.edit_user') : t('organization.add_user')}
                      </CBButton>
                      {editUser && <CBButton onClick={clearUser}>{t('organization.cancel_edit')}</CBButton>}
                  </div>
                </CBCard>
              ) : (
                <div className="p-4 m-4 text-lg cursor-pointer text-blue-600 hover:underline"
                     onClick={() => handleMenuClick('billing')}>
                  {t('organization.purchase_user_seats')}
                </div>
              )}

              <div className="mt-6">
                <h5 className="text-lg font-semibold mb-2">{t('organization.user_accounts')}</h5>
                <h5 className="text-sm text-gray-600 mb-4">{t('organization.user_count')} {org?.users?.length || 0}</h5>
                <div className="mb-4">
                  <CBInput
                    hint={t('organization.search_users_placeholder')}
                    allowClear
                    onChange={(val) => {
                      if (!val || val === '') setFilterUsers(org?.users || []);
                      else {
                        const searchTerm = val.toLowerCase();
                        setFilterUsers((org?.users || []).filter(b => b.email?.toLowerCase().includes(searchTerm)));
                      }
                    }}
                  />
                </div>
                <CBTable
                  dataSource={filterUsers}
                  columns={userTableColumns}
                  rowKey="userId"
                  pagination={{ pageSize: 10 }} // Enable pagination for user table
                  loading={load}
                  className="mb-4"
                  scroll={{ x: 'max-content' }} // Enable horizontal scroll if needed
                />
                 {/* Add CBPagination if needed - CBTable has built-in pagination */}
              </div>
            </>
          )}
          {showDomainManagement && org && (
            <>
              <div className="flex flex-col  m-4 p-4 bg-white  w-full  "> {/* Wider width */}
                {/* <CBHeader
                  icon={<Connections />} label={t('organization.manage_domains')}
                  buttonLabel={t('common.help')} buttonIcon={<FontAwesomeIcon icon={faInfoCircle} />} // Use imported icon
                  buttonAction={(e) => { window.open('https://help.calendarbridge.com/doc/group-account-management/managing-authorized-domains/', '_blank') }}
                /> */}
                <div className="w-[600px]">
                <CBButton long={true}
                icon={showAddDomain ? <div></div> : <Add style={{float:'right'}} ></Add>} type={showAddDomain ? 'ternary' : 'primary'} onClick={() => setShowAddDomain(!showAddDomain)}>
                      {showAddDomain ? t('organization.hide_domain') : t('organization.add_domain')}
                    </CBButton>
                    </div>
              {showAddDomain && <div className="flex flex-col  m-4 p-4 bg-neutral lg:w-2/3 rounded shadow"> {/* Wider width */}
                <div className="text-lg font-semibold">{t('organization.add_domain')}</div>
                <div className="mt-2">
                  <CBInput
                    label={t('organization.domain_name_label')} placeholder={t('organization.domain_placeholder')}
                    value={addedDomain || ''}
                    onChange={(val) => { setAddedDomain(val.toLowerCase()); setAccept(false); setDomainError(''); }}
                    className="mb-2"
                  />
                </div>
                <div className="mt-2">
                  <CBRadioGroup
                    title={t('organization.tennant_type_label')} selectedValue={tennantType}
                    labels={[t('accounts.microsoft_365_account'),t('accounts.google_account')]}
                    values={['ms','google']}
                    selected={tennantType}
                    onChange={( val) => setTennantType(['ms','google'][val])} className="mb-2"
                  />
                </div>
                <div className="m-2 p-4 bg-gray-100 rounded text-sm">
                  {tennantType == 'ms' ? (
                    <div><a href="https://help.calendarbridge.com/group-admin-docs/authorizing-access-for-managed-syncs/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">{t('organization.msft_365_instructions_link_text')}</a></div>
                  ) : (
                    <div><a href="https://help.calendarbridge.com/group-admin-docs/authorizing-access-for-managed-syncs/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">{t('organization.google_workspace_instructions_link_text')}</a></div>
                  )}
                </div>
                <CBCheckbox
                  disabled={!addedDomain?.trim()} checked={accept} onChange={setAccept}
                  label={t('organization.followed_instructions_checkbox')} className="mb-2"
                />
                {accept && (
                  <div className="mt-4">
                    <p className="text-lg mb-1">{t('organization.verify_setup_email_prompt')}</p>
                    <CBInputWithSelectAddon
                      value={testEmail || ''} label={t('organization.test_email_label')} allowClear
                      placeholder={t('organization.address_placeholder')}
                      onChange={(val) => {
                          const entry = val.trim();
                          const namePart = entry.includes('@') ? entry.substring(0, entry.indexOf('@')) : entry;
                          setTestEmail(namePart);
                      }}
                      addonElement={addedDomain ? <div className="pl-6 pr-6 tex-lg">@{addedDomain}</div> : null} className="mb-2"
                    />
                  </div>
                )}
                {domainError && <CBAlert variant="error" message={domainError} className="mb-2"/>}
                <CBButton
                long={true}
                icon={<Add style={{float:'right'}} ></Add>}
                  loading={quickSyncLoading}
                  disabled={!accept || !testEmail?.trim() || !addedDomain?.trim()}
                  onClick={addCustomDomain} className="mt-2"
                >
                  {t('organization.add_domain')}
                </CBButton>
              </div>}
                 {/* Display existing domains */}
                 <div className="mt-4">
                     <h4 className="font-semibold mb-2">{t('organization.authorized_domains')}</h4>
                     {org.organization?.allowedDomains?.length > 0 ? (
                         <ul className="list-disc space-y-1">
                          {console.log(org.organization.allowedDomains)}
                             {org.organization.allowedDomains.map((d, i) => (
                                 <li key={i} className="text-xl flex rounded-sm justify-between items-center p-4 border">
                                     <span>{d.domain} ({d.type})</span>
                                     {/* Add a remove button if needed - requires confirmation */}
                                     <CBButton size="small" type="danger" onClick={() => removeDomain(d.domain, d.type)} loading={quickSyncLoading}>{t('common.remove_button')}</CBButton>
                                 </li>
                             ))}
                         </ul>
                     ) : (
                         <p className="text-sm text-gray-500">{t('organization.no_domains_authorized')}</p>
                     )}
                 </div>
              </div>
              
            </>
          )}
        </div>
      )}

       {/* Delete User Modal */}
       <CBModal
          title={t('organization.delete_user')}
          visible={showDeleteUserModal}
          onPositiveClick={deleteUserAccount}
          onCancelClick={() => { setUserToDelete(null); setShowDeleteUserModal(false); }}
          positiveLabel={t('common.delete_button')}
          negativeLabel={t('common.cancel_button')}
          positiveButtonProps={{ className: 'bg-red-600 hover:bg-red-700' }}
        >
           <div className="flex items-center">
              <FontAwesomeIcon icon={faTrashAlt} className="text-red-600 text-xl mr-3 mb-8" />
              <p>{t('organization.delete_user_confirm', { email: userToDelete?.email })}</p>
           </div>
       </CBModal>

    </div>
  )
}
// --- End OrgItem Component ---


// --- OrganizationPage Component ---
const OrganizationPage = (props) => {
  const { t } = useLocalization()
  const [license] = useGlobalState('license')
  const [currentOrg, setCurrentOrg] = useState(null)

  useEffect(() => {
    // Set initial org only if license is loaded and has orgId
    if (license?.orgId) {
        setCurrentOrg(license.orgId.split(',')[0]);
    }
  }, [license]) // Depend only on license

  const handleOrgMenuClick = (key) => {
    setCurrentOrg(key)
  }
const getOrg = () => {
  if (currentOrg == null) return <div className="p-4 text-center">{t('organization.loading_org')}</div>
  // Pass license down to OrgItem (t is now handled internally by OrgItem)
  return <OrgItem key={currentOrg} org={currentOrg} license={license} />
}

return (
    // Replaced Layout with div
    <div className="cb-content-frame bg-white">
      <div className="m-4 md:m-8" style={{ minHeight: 800 }}> {/* Adjusted margin */}
        <CBHeader
          icon={<Connections />}
          label={t('organization.manage_organization')}
        />

        {!license && ( // Show loading if license is not yet available
          <center className="mt-8">
             <CBSpin spinning={true} size="large"  />
          </center>
        )}
        {/* {license && !license.orgAdmin && <div className="p-4 text-center text-red-600">{t('organization.not_admin')}</div>} */}
        {license && license.orgAdmin && (
          <>
            {/* Replaced Menu with Buttons */}
            <div className="flex flex-wrap border-b mb-4 gap-x-2 items-center">
              {(license.orgId || '').split(',').map((orgId) => (
                  <CBButton
                      key={orgId}
                      type={currentOrg === orgId ? "primary-tab" : "ternary-tab"} // Highlight selected org
                      onClick={() => handleOrgMenuClick(orgId)}
                      className="m-1" // Add some margin
                  >
                      {orgId}
                  </CBButton>
              ))}
            </div>
            {getOrg()}
          </>
        )}
      </div>
    </div>
  )
}

export default OrganizationPage;

// Removed helper function getOptions as it's handled inline now
